<template>
    <card-renderless v-slot="{
        title,
        subtitle,
        link,
        image,
        theme,
        isSelected,
        isOnBillboard,
        hasSubitems,
        toggleDetails,
        sendToBillboard,
        isCurrentPage,
        size,
    }">
        <div class="relative flex flex-col w-full h-full bg-center bg-no-repeat bg-cover rounded shadow-md select-none t3m-Card t3m-Card--flx card swiper-lazy"
             @mouseenter="sendToBillboard"
             :class="{
                 'selected z-10 ring-2 ring-white ring-opacity-70': isSelected,
                 't3m-Card--flx-dark bg-black': theme === 'dark',
                 't3m-Card--flx-light bg-white': theme === 'light',
                 't3m-Card--flx-currentPage z-20': isCurrentPage,
                 'lg:aspect-video': size === 'auto',
                 'lg:aspect-2 overflow-hidden': size === 'sm',
                 'lg:aspect-video overflow-hidden': size === 'md',
                 'lg:aspect-1 overflow-hidden': size === 'lg',
                 'onBillboard z-10 ring-2 !ring-primary': isOnBillboard,
             }"
             :data-background="image">
            <div class="absolute inset-0 rounded"
                 :class="{
                     'bg-black bg-opacity-60': theme === 'dark',
                     'bg-white bg-opacity-60': theme === 'light',
                 }"></div>
            <div class="swiper-lazy-preloader"></div>
            <div class="absolute w-0 h-0 -ml-4 border-x-transparent t3m-Card-arrow border-x-8 left-1/2"
                 :class="{
                     'border-b-primary border-b-8 bottom-full': isOnBillboard,
                 }"></div>
            <a v-if="link.length"
               :href="link"
               class="relative flex-grow px-4 pt-4 no-underline xl:px-6 xl:pt-6 card-body"
               :class="{
                   'text-white hover:text-white': theme === 'dark',
                   'text-t3m-body hover:text-t3m-body': theme === 'light',
                   'pb-12': hasSubitems,
                   'pb-4': !hasSubitems,
               }"
               :aria-label="title">
                <h3 class="flex items-baseline mb-2 font-bold t3m-Card-title hover:text-primary">
                    <span v-html="title"
                          class="t3m-u-flx-readability"></span>
                </h3>
                <div v-if="subtitle"
                     class="hidden text-sm t3m-Card-text card-text"
                     :class="{
                         'md:line-clamp-2': size === 'sm',
                         'md:line-clamp-3': size === 'md',
                         'md:line-clamp-4': size === 'lg',
                     }">
                    <span v-html="subtitle"
                          class="t3m-u-flx-readability"></span>
                </div>
            </a>
            <div v-if="!link.length"
                 class="relative flex-grow px-4 pt-4 xl:px-6 xl:pt-6 card-body"
                 :class="{
                     'text-white': theme === 'dark',
                     'pb-12': hasSubitems,
                     'pb-4': !hasSubitems,
                 }">
                <h3 class="flex items-baseline mb-2 font-bold t3m-Card-title">
                    <span v-html="title"
                          class="t3m-u-flx-readability"></span>
                </h3>
                <div v-if="subtitle"
                     class="hidden text-sm t3m-Card-text card-text"
                     :class="{
                         'md:line-clamp-2': size === 'sm',
                         'md:line-clamp-3': size === 'md',
                         'md:line-clamp-4': size === 'lg',
                     }">
                    <span v-html="subtitle"
                          class="t3m-u-flx-readability"></span>
                </div>
            </div>
            <div class="absolute inset-x-0 bottom-0 flex justify-end p-3 rounded-b group bg-gradient-to-t from-black card-footer"
                 @click="toggleDetails"
                 v-if="hasSubitems">
                <span class="inline-block p-1 text-white rounded-full cursor-pointer bg-primary hover:bg-primary-hover"
                      :class="{
                          'rotate-180': isSelected
                      }">
                    <span class="sr-only">
                        Show subnavigation
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="w-4 h-4"
                         viewBox="0 0 448 512"
                         fill="currentColor">
                        <path
                              d="M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z" />
                    </svg>
                </span>
            </div>

        </div>
    </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
    components: {
        CardRenderless,
    },
};
</script>
